/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown> }} Uploadedimagealt2Inputs */

const en_uploadedimagealt2 = /** @type {(inputs: Uploadedimagealt2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Image ${i?.index}`)
};

const de_uploadedimagealt2 = /** @type {(inputs: Uploadedimagealt2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bild ${i?.index}`)
};

/**
* | output |
* | --- |
* | "Image {index}" |
*
* @param {Uploadedimagealt2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const uploadedimagealt2 = /** @type {((inputs: Uploadedimagealt2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uploadedimagealt2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_uploadedimagealt2(inputs)
	return de_uploadedimagealt2(inputs)
});
export { uploadedimagealt2 as "uploadedImageAlt" }